const WebUrl = () => {

    let link = '';
    if ( window.location.hostname === 'localhost') {
        link = 'http://localhost:3000'
    }else{
        link = 'https://profile.vox.pl'
    }

    return link;
}

export default WebUrl;